export function Footer() {
  return (
    <footer className="bg-foreground text-cream py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          {/* Brand */}
          <div>
            <a href="/" className="flex items-center gap-2.5 mb-6">
              <div className="w-9 h-9 bg-forest rounded-lg flex items-center justify-center">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  className="w-5 h-5 text-cream"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" />
                  <circle cx="15.5" cy="8.5" r="1.5" fill="currentColor" />
                  <circle cx="8.5" cy="15.5" r="1.5" fill="currentColor" />
                  <circle cx="15.5" cy="15.5" r="1.5" fill="currentColor" />
                </svg>
              </div>
              <span className="font-serif text-xl font-semibold text-cream tracking-tight">
                Corkboard
              </span>
            </a>
            <p className="text-cream/60 text-sm leading-relaxed max-w-md">
              A community-owned intelligence engine connecting residents, retailers, and
              visitors through local offers, events, and experiences.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-cream mb-4">Product</h4>
            <ul className="space-y-3">
              {["How It Works", "For Residents", "For Retailers", "Our Approach"].map(
                (link) => (
                  <li key={link}>
                    <a
                      href={`#${link.toLowerCase().replace(/\s/g, "-")}`}
                      className="text-cream/60 hover:text-cream transition-colors text-sm"
                    >
                      {link}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-cream/40 text-sm">
            &copy; {new Date().getFullYear()} Corkboard. Built with care for local communities.
          </p>
          <a
            href="https://turtledove.dev"
            target="_blank"
            rel="noopener noreferrer"
            className="text-cream/60 hover:text-cream transition-colors text-sm flex items-center gap-1.5"
          >
            Made with <span className="text-red-400">♥</span> by Turtledove
          </a>
        </div>
      </div>
    </footer>
  )
}
